import resize from "../resize";
import Swiper from "swiper";

const initFaqSlider = () => {
   const slider = document.querySelector(".faq__slider");
   let swiper = null;

   function init() {
      if (!swiper) {
         swiper = new Swiper(slider, {
            observer: true,
            observeParents: true,
            loop: false,
            spaceBetween: 10,
            breakpoints: {
              650: {
                slidesPerView: 3.4,
              },
              500: {
                slidesPerView: 2.7,
              },
              370: {
                slidesPerView: 2.05,
              },
              0: {
                slidesPerView: 1.8
              },
            },
         });
      }
   }

   function destroy() {
      if (swiper) {
         swiper.destroy();
         swiper = null;
      }
   }

   function resizeSwiper() {
      window.innerWidth <= 767
         ? init()
         : destroy()
   }

   slider && resizeSwiper();
   slider && resize(resizeSwiper);
};

export default initFaqSlider;
